import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { TransactionService } from 'src/app/services/transaction.service';
import { AlertComponent } from 'src/app/alert/alert.component';

declare var $: any;

@Component({
  selector: 'app-payment-proof',
  templateUrl: './payment-proof.component.html',
  styleUrls: ['./payment-proof.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentProofComponent implements OnInit {
  transaction_id: string;
  payment_guide: any;
  popup_message_payment_proof: any;

  @ViewChild('alertComponent') alertComponent: AlertComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private clipboardService: ClipboardService,
    private toastr: ToastrService,
    private transactionService: TransactionService
  ) {
    this.transaction_id = route.snapshot.params.id;
    this.payment_guide = route.snapshot.data.payment_guide;
    this.popup_message_payment_proof = route.snapshot.data.popup_message_payment_proof;

    window.scrollTo(0, 0);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  open() {
    $('#modal-upload-payment-proof').modal("show");
  }

  copyAccountNumber(copyText, accountNumber: string) {
    this.clipboardService.copyFromContent(accountNumber);
    this.toastr.success(copyText, '', {
      timeOut: 3000
    });
  }

  onFileChanged(files: FileList): void {
    if (files.length > 0) {
      const file = files.item(0);

      const file_size = file.size / 1024 / 1024;

      $('#modal-upload-payment-proof').modal("hide");
      if (file_size <= 25) {
        $('#loader').modal('show');
        this.transactionService.uploadPaymentProof(this.transaction_id, file,
          (data) => {
            $('#loader').modal('hide');
            this.router.navigate(['/transaction']);
          },
          (err) => {
            $('#loader').modal('hide');
            this.alertComponent.show('Bukti Transfer Gagal Dikirim', err.error.alert.message);
          }
        );
      } else {
        this.alertComponent.show('', 'Ukuran file maksimal 25MB');
      }
    }
  }
}
